import { Alert, Typography } from '@statsbomb/kitbag-components';

const InfoBarWrapper = ({ testId, children }: { testId?: string; children?: React.ReactNode }) => (
  <Alert testId={testId}>
    <div className="flex flex-col gap-x-5 bg-transparent [&>svg]:text-messaging-info-main leading-3">{children}</div>
  </Alert>
);

export const InfoBar = ({
  testId,
  mainText,
  additionalText,
}: {
  testId?: string;
  mainText: string;
  additionalText?: string;
}) => (
  <InfoBarWrapper testId={testId}>
    <Typography as="span" variant="bodyMedium">
      {mainText}
      {additionalText && (
        <Typography as="span" variant="headingSmall">
          &nbsp;
          {`${additionalText}`}
        </Typography>
      )}
    </Typography>
  </InfoBarWrapper>
);

export const InfoBarWithChild = ({ testId, children }: { testId: string; children?: React.ReactNode }) => (
  <InfoBarWrapper testId={testId}>
    <Typography as="span" variant="bodyMedium">
      {children}
    </Typography>
  </InfoBarWrapper>
);
